import { z } from 'zod';
import { entitlementNameSchema } from '../EntitlementNames';
import { stripeAccountNameSchema } from '../StripeAccount';

/** @deprecated - scheduled subscriptions are now a part of the entitlements array */
export const ScheduledSubscription = z.object({
  subscriptionScheduleId: z.string(),
  startDateMillis: z.number(),
  entitlement: entitlementNameSchema,
  sku: z.string().optional(),
  isSimulated: z.boolean().optional(),
  stripeAccountName: stripeAccountNameSchema,
});

/** @deprecated - scheduled subscriptions are now a part of the entitlements array */
export type ScheduledSubscription = z.infer<typeof ScheduledSubscription>;
